import script from "./SecondTask.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondTask.vue?vue&type=script&setup=true&lang=js"

import "./SecondTask.vue?vue&type=style&index=0&id=381ed56e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-381ed56e"]])

export default __exports__